import { pedagogicalApproachParameters } from '../../../../../utils/defaultsProvider'

class ParameterListController {
    /**
     * @param $state
     * @param $stateParams
     * @param $http
     */
    constructor($state, $stateParams, $http) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$http = $http;

        this.pedagogicalApproachParams = [];
    }

    $onInit() {
        this.init();
    }

    init() {
        this.pedagogicalApproachParams = pedagogicalApproachParameters;
    }

    gotoTab(paramIndex) {
        this.$state.go(this.$state.current, { activeParameter: paramIndex }, { reload: false });
    }

    isCurrentGoal(paramIndex) {
        return paramIndex === +this.$stateParams.activeParameter;
    }
}

ParameterListController.$inject = [
    '$state',
    '$stateParams',
    '$http',
];

export default ParameterListController;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/parametersList/parameterListController.js